const CyberGrid = () => (
  <div className="cyber-grid" aria-hidden="true" />
);

export default CyberGrid;
